import { computed, ComputedRef, Ref } from "vue"
import { Step } from "../../entities/NSwagGenerated"

/**
 * Returns a computed string describing the output unit for a given step in the result tabs.
 *
 * Rules:
 * - Biologics / Synthetic API → "drug substance"
 * - Product Process            → "drug product"
 * - When the selected step is "All Steps" or the last active step → just the substance name
 * - Otherwise → "intermediate {substance name}"
 * - Unknown module → fallback to "{stepNumber} {stepName}"
 */
export function useStepOutputDescription(
	tabName: Ref<string> | ComputedRef<string>,
	selectedStep: Ref<Step | undefined> | ComputedRef<Step | undefined>,
	steps: Ref<Step[]> | ComputedRef<Step[]>
) {
	return computed(() => {
		const currentTab = tabName.value || ""
		const currentStep = selectedStep.value

		let substanceName = ""
		if (currentTab === "Biologics" || currentTab === "Synthetic API") {
			substanceName = "drug substance"
		} else if (currentTab === "Product Process") {
			substanceName = "drug product"
		}

		if (!substanceName) {
			return `${currentStep?.stepNumber ?? ""} ${currentStep?.stepName ?? ""}`.trim()
		}

		const activeSteps = (steps.value || [])
			.filter((s: any) => s.isActive !== false)
			.sort((a: any, b: any) => (a.stepNumber || 0) - (b.stepNumber || 0))
		const lastStep = activeSteps[activeSteps.length - 1]

		const isAllSteps = currentStep?.stepName === "All Steps"
		const isLastStep = !!lastStep && !!currentStep?.id && (currentStep as any).id === (lastStep as any).id

		if (isAllSteps || isLastStep) {
			return substanceName
		}

		return `intermediate ${substanceName}`
	})
}
